import * as PIXI from 'pixi.js';

const UI_FONT_FAMILY = 'BoldPixels';

export function configurePixiDefaults(): void {
  PIXI.settings.SORTABLE_CHILDREN = true;
  PIXI.settings.ROUND_PIXELS = true;
  // Pixel-art: NEAREST by default on every texture (LINEAR blurs scaled
  // sprites). Makes it global (hub background, sprites loaded on the fly).
  PIXI.settings.SCALE_MODE = PIXI.SCALE_MODES.NEAREST;
  // Single UI font for React + Pixi: any Pixi `Text` without an explicit
  // fontFamily inherits BoldPixels.
  PIXI.TextStyle.defaultStyle.fontFamily = UI_FONT_FAMILY;
}

export function loadUiFont(): Promise<unknown> {
  return document.fonts
    ? document.fonts.load(`16px '${UI_FONT_FAMILY}'`).catch(() => undefined)
    : Promise.resolve(undefined);
}
